import { render } from "./SeoList.vue?vue&type=template&id=71989192&scoped=true&ts=true"
import script from "./SeoList.vue?vue&type=script&lang=ts"
export * from "./SeoList.vue?vue&type=script&lang=ts"

import "./SeoList.vue?vue&type=style&index=0&id=71989192&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71989192"]])

export default __exports__